import { useState, RefCallback } from 'react';

/**
 * @example const [element, setElementFunction] = useElement(initial);
 * @param initial The initial value to set to element.
 * @returns * element:: A DOM Element.
 *          * setElementFunction:: The function responsible for setting and resetting the element variable. This function is typically passed to the ref attribute of the element you wish to reference.
 */
const useElement = <T extends Element>(initial: T | null = null): [T | null, RefCallback<T>] =>
  useState<T | null>(initial);

export default useElement;
